<template lang="pug">
  .bubbles
    .Header-hero(:class="{ 'active' : $root.show_details }")
      .IconsContainer
        .Avatar(v-for="(avatar, index) in avatars", :style="{ transform: 'translate(' + avatar.x + 'px, ' + avatar.y + 'px) scale(' + avatar.s + ')', background: 'url(/images/avatars/' + (index + 1) + '.png)' }")
          span {{ getTitle().nombre }}
</template>

<script>

export default {
  props: {
    dataConcurse: Array
  },
  data() {
    return {
      avatars: [
        {
          s: .6,
          x: 1134,
          y: 45
        }, {

          s: .6,
          x: 1620,
          y: 271
        }, {

          s: .6,
          x: 1761,
          y: 372
        }, {

          s: .6,
          x: 2499,
          y: 79
        }, {

          s: .6,
          x: 2704,
          y: 334
        }, {

          s: .6,
          x: 2271,
          y: 356
        }, {

          s: .6,
          x: 795,
          y: 226
        }, {

          s: .6,
          x: 276,
          y: 256
        }, {

          s: .6,
          x: 1210,
          y: 365
        }, {

          s: .6,
          x: 444,
          y: 193
        }, {

          s: .6,
          x: 2545,
          y: 387
        }, {

          s: .8,
          x: 1303,
          y: 193
        }, {

          s: .8,
          x: 907,
          y: 88
        }, {

          s: .8,
          x: 633,
          y: 320
        }, {

          s: .8,
          x: 323,
          y: 60
        }, {

          s: .8,
          x: 129,
          y: 357
        }, {

          s: .8,
          x: 1440,
          y: 342
        }, {

          s: .8,
          x: 1929,
          y: 293
        }, {

          s: .8,
          x: 2135,
          y: 198
        }, {

          s: .8,
          x: 2276,
          y: 82
        }, {

          s: .8,
          x: 2654,
          y: 182
        }, {

          s: .8,
          x: 2783,
          y: 60
        }, {

          s: 1,
          x: 1519,
          y: 118
        }, {

          s: 1,
          x: 1071,
          y: 233
        }, {

          s: 1,
          x: 1773,
          y: 148
        }, {

          s: 1,
          x: 2098,
          y: 385
        }, {

          s: 1,
          x: 2423,
          y: 244
        }, {

          s: 1,
          x: 901,
          y: 385
        }, {

          s: 1,
          x: 624,
          y: 111
        }, {

          s: 1,
          x: 75,
          y: 103
        }, {

          s: 1,
          x: 413,
          y: 367
        }, {

          s: 1,
          x: 2895,
          y: 271
        }, {

          s: 1,
          x: 1990,
          y: 75
        }
      ],
    }
  },
  methods: {
    getTitle() {
      let max = this.dataConcurse.length
      let value = Math.floor(Math.random() * max)
      return this.dataConcurse[value]
    }
  },
  mounted() {

  }
}
</script>

<style lang="sass" scoped>
  .Header-hero
    position: fixed
    bottom: 0
    height: 30vh
    display: -webkit-box
    display: -ms-flexbox
    display: flex
    -webkit-box-align: center
    -ms-flex-align: center
    align-items: center
    transition: all 2s ease
    &.active
      transform: translateY(90%)
  .IconsContainer
    width: 3000px
    height: 460px
    position: relative
    left: 0
    animation: moveIcons 120s linear infinite alternate
    will-change: transform, opacity
    & .Avatar
      width: 150px
      height: 150px
      position: absolute
      will-change: transform, opacity
      margin: -75px 0 0 -75px
      box-shadow: 0 15px 35px rgba(0,0,0,.1), 0 3px 10px rgba(0,0,0,.07)
      border-radius: 50%
      opacity: .3
      background-position: center !important
      background-size: 60% !important
      background-color: #fff !important
      background-repeat: no-repeat !important
      & span
        position: absolute
        will-change: transform, opacity
        left: 50%
        bottom: -40px
        padding: 5px 12px
        background: #fff
        -webkit-box-shadow: 0 15px 35px rgba(50,50,93,.1),0 5px 15px rgba(0,0,0,.07)
        box-shadow: 0 15px 35px rgba(50,50,93,.1),0 5px 15px rgba(0,0,0,.07)
        border-radius: 50px
        white-space: nowrap
        font-size: 16px
        font-weight: 500
        color: #566b78
        pointer-events: none
        -webkit-user-select: none
        -moz-user-select: none
        -ms-user-select: none
        user-select: none
        -webkit-transform: translate(-50%,-10px)
        transform: translate(-50%,-10px)
        opacity: 0
        -webkit-transition-property: opacity,-webkit-transform
        transition-property: opacity,-webkit-transform
        transition-property: opacity,transform
        transition-property: opacity,transform,-webkit-transform
        -webkit-transition-duration: .25s
        transition-duration: .25s
        -webkit-transition-timing-function: ease-out
        transition-timing-function: ease-out
      &:hover
        opacity: 1
        & span
          opacity: .9
          -webkit-transform: translate(-50%)
          transform: translate(-50%)
  @keyframes moveIcons
    from
      transform: translateX(0%)
    to
      transform: translateX(-50%)
</style>



// WEBPACK FOOTER //
// resources/js/components/Winners2019/BubblesAvatars.vue